import { Link as LinkComponent } from 'src/components';
import styled, { css } from 'styled-components';

export const Link = styled(LinkComponent)(
  ({ theme }) => css`
    display: block;
    width: ${theme.sz.s16};
    aspect-ratio: 100/91;

    svg {
      width: 100%;
      height: 100%;
    }
  `,
);
